import { FC, useState } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { FileInfo } from "../../types";
import { getMimeType, isEmbed, isImage, isMobile, isVideo } from "../../types/utils";
import SvgPaperClip from "../icons/PaperClip";
import Icon from "./Icon";
import styles from "./ListFiles.module.css";
import { getDownloadAction, getPreviewAction } from "./ListItemMenu";
import PreviewFileDialog from "./PreviewFileDialog";
import Table from "./Table";

type ListFileProps = {
  files: FileInfo[];
};

const ListFiles: FC<ListFileProps> = ({ files }: ListFileProps) => {
  const i18n = useI18n();
  const [itemToPreview, setItemToPreview] = useState<{ name: string; url: string }>();

  const downloadDocument = (item: FileInfo) => {
    if (item.name) {
      const link = document.createElement("a");
      link.href = `${getMimeType(item.name)}${item.data}`;
      link.setAttribute("download", item.name);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    }
  };

  const onPreviewClick = async (item: FileInfo) => {
    if (item.name && !isMobile && (isVideo(item.name) || isImage(item.name) || isEmbed(item.name))) {
      setItemToPreview({ name: item.name, url: `${getMimeType(item.name)}${item.data}` });
      return;
    }
    downloadDocument(item);
  };

  return (
    <>
      <div>
        <Table<FileInfo>
          renderRow={(f) => (
            <td className={styles.tdContainer} onClick={() => onPreviewClick(f)}>
              {f.name && isImage(f.name) ? (
                <img src={`${getMimeType(f.name)}${f.data}`} className={styles.preview} />
              ) : (
                <Icon glyph={SvgPaperClip} className={styles.preview} />
              )}

              <div className={styles.name}>{f.name}</div>
            </td>
          )}
          rowActions={(item) => [
            getPreviewAction(i18n, () => onPreviewClick(item)),
            getDownloadAction(i18n, () => downloadDocument(item)),
          ]}
          items={files}
        ></Table>
      </div>

      {!!itemToPreview && (
        <PreviewFileDialog
          fileName={itemToPreview.name}
          onClose={() => setItemToPreview(undefined)}
          docUrl={itemToPreview.url}
        />
      )}
    </>
  );
};

export default ListFiles;
